import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import SubmissionVsUnderwritingStore from '../components/common/store/submissionVsUnderwritingStore';

export const useSubmissionVsUnderwritingStore = () => useContext<{
  submissionVsUnderwritingStore: SubmissionVsUnderwritingStore
}>(StoreContext);
